export default __webpack_public_path__ + "static/media/ICON KEUNGGULAN-MOOR LIFETIME GUARANTEE.efdea23f.png";